import { injectable as Injectable } from 'inversify-props';

export default Injectable;
